import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ISetLookupPriceData } from '../../hooks/dashboard/driver-lookup/useSetLookupPrice';

interface IInitialState {
  paymentData?: ISetLookupPriceData;
}
const initialState: IInitialState = {
  paymentData: undefined,
};

const paymentLinkSlice = createSlice({
  name: 'paymentLink',
  initialState,
  reducers: {
    setPaymentData(state, action: PayloadAction<ISetLookupPriceData | undefined>) {
      state.paymentData = action.payload;
    },
  },
});

export const paymentLinkActions = paymentLinkSlice.actions;
export default paymentLinkSlice.reducer;
